<div class="pageheader">
    <div class="page-title">
        <h1>Control Test</h1>
    </div>
</div>

<!--  ----------  REACTIVE FORM  ----------  -->

<div style="border: 1px dashed">
    <form [formGroup]="reactiveFormGroup" (ngSubmit)="reactiveFormSubmit()">
        <app-layout-container fluid>
            <app-layout-row>
                <app-layout-column [width]="4">
                    <span>Reactive form</span>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-textbox formControlName="name" caption="Name" [calculateValidationText]="getValidationText" helpText="Your full name"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-textbox formControlName="email" caption="Email"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="1" offset="4">
                    <app-textbox formControlName="zip" caption="Zip"></app-textbox>
                </app-layout-column>
                <app-layout-column [width]="3">
                    <app-textbox formControlName="city" caption="City"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="6">
                    <app-checkbox formControlName="allowShowPassword" caption="Allow show password" helpText="Only applies to secret based passwords"></app-checkbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-password formControlName="passwordHash" caption="Password (Hashed)" [allowShowPassword]="allowShowPassword()" section="reactiveHash" mode="hash" helpText="This is a hash based password"></app-password>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-password formControlName="passwordSecret" caption="Password (Secret)" [allowShowPassword]="allowShowPassword()" section="reactiveSecret" mode="secret" helpText="This is a secret based password"></app-password>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-xpath formControlName="xpath" caption="XPath" helpText="What' you think?"></app-xpath>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-singleselectbox formControlName="backgroundColor" caption="Background color" helpText="Please pick a color" [dataSource]="colors" valueExpr="id"
                        displayExpr="name"></app-singleselectbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-singleselectbox formControlName="foregroundColor" caption="Foreground color" helpText="Please pick a color" [dataSource]="colors" valueExpr="id"
                        displayExpr="name"></app-singleselectbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-multiselectbox formControlName="moreColors" caption="More Colors" helpText="Please pick some colors" [dataSource]="colors" valueExpr="id"
                        displayExpr="name"></app-multiselectbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-multiselectbox formControlName="otherColors" [dataSource]="colors" valueExpr="id" displayExpr="name"
                        caption="Other Colors - please pick all the colors you like and make this a very long text caption"
                        helpText="Please pick some colors and then some more colors and finish up with even more colors"></app-multiselectbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-checkbox formControlName="receiveNewsletter" caption="Receive newsletter" helpText="We send monthly newsletters"></app-checkbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-datetimebox datetime formControlName="datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
                        helpText="Specify a date and a time"></app-datetimebox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-datetimebox date formControlName="date" caption="Date" minDate="2024-05-01" helpText="Specify just a date and no time"></app-datetimebox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-datetimebox time formControlName="time" caption="Time" [timeInterval]="10" helpText="Specify just a time and no date"></app-datetimebox>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    @if (reactiveFormGroup.enabled) {
                    <app-layout-row margin="">
                        <app-layout-column [width]="4">
                            <app-button primary submit width="100%" [disabled]="!reactiveFormGroup.valid">Save</app-button>
                        </app-layout-column>
                        <app-layout-column [width]="4">
                            <app-button secondary width="100%" (buttonClick)="reactiveFormCancel()">Cancel</app-button>
                        </app-layout-column>
                        <app-layout-column [width]="4">
                            <app-button tertiery width="100%" (buttonClick)="reactiveFormClear()">Clear</app-button>
                        </app-layout-column>
                    </app-layout-row>
                    } @else {
                    <app-button primary width="100%" (buttonClick)="reactiveFormEdit()">Edit</app-button>
                    }
                </app-layout-column>
                <app-layout-column [width]="1">
                    <app-button secondary width="100%" (buttonClick)="reactiveFormPatch()" [disabled]="!reactiveFormGroup.disabled">Patch</app-button>
                </app-layout-column>
                <app-layout-column [width]="1">
                    <app-button secondary width="100%" (buttonClick)="refresh()" [disabled]="!reactiveFormGroup.disabled">Reload</app-button>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <div>Form: {{reactiveFormGroup.value | json}}</div>
                    <br>
                    <div>Data: {{this.myData | json}}</div>
                </app-layout-column>
            </app-layout-row>
        </app-layout-container>
    </form>
</div>

<br>


<!--  ----------  TEMPLATE FORM  ----------  -->

<div style="border: 1px dashed">
    <form (ngSubmit)="templateFormSubmit()" #tForm="ngForm">
        <app-layout-container fluid>
            <app-layout-row>
                <app-layout-column [width]="4">
                    <span>Template form</span>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-textbox [ngModel]="myData.name" name="name" caption="Name" required maxlength="10" pattern="[a-zA-Z ]*" [calculateValidationText]="getValidationText"
                        helpText="Your full name"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-textbox #email [ngModel]="myData.email" name="email" caption="Email" email [appConditionalValidator]="newsletterValidators" [condition]="newsletterCondition"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="1" offset="4">
                    <app-textbox [ngModel]="myData.zip" name="zip" caption="Zip" (valueChange)="updateValidation([city])"></app-textbox>
                </app-layout-column>
                <app-layout-column [width]="3">
                    <app-textbox #city [ngModel]="myData.city" name="city" caption="City" [appConditionalValidator]="zipValidators" [condition]="zipCondition"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-password [ngModel]="myData.passwordHash" name="passwordHash" caption="Password (Hashed)" section="templateHash" mode="hash" helpText="This is a hash based password"></app-password>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-password [ngModel]="myData.passwordSecret" name="passwordSecret" caption="Password (Secret)" section="templateSecret" mode="secret" helpText="This is a secret based password"></app-password>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <app-xpath [ngModel]="myData.xpath" name="xpath" caption="XPath" required maxlength="20" helpText="What' you think?"></app-xpath>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-singleselectbox name="backgroundColor" caption="Background color" helpText="Please pick a color" [ngModel]="myData.backgroundColor" [dataSource]="colors" valueExpr="id"
                        displayExpr="name"></app-singleselectbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-singleselectbox name="foregroundColor" caption="Foreground color" helpText="Please pick a color" [ngModel]="myData.foregroundColor" [dataSource]="colors" valueExpr="id"
                        displayExpr="name" required></app-singleselectbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-multiselectbox name="moreColors" caption="More colors" helpText="Please pick some colors" [ngModel]="myData.moreColors" [dataSource]="colors" valueExpr="id"
                        displayExpr="name"></app-multiselectbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-multiselectbox name="otherColors" caption="Other colors" helpText="Please pick some colors" [ngModel]="myData.otherColors" [dataSource]="colors" valueExpr="id"
                        displayExpr="name" required></app-multiselectbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-checkbox name="receiveNewsletter" caption="Receive newsletter" [ngModel]="myData.receiveNewsletter" (valueChange)="updateValidation([email])"></app-checkbox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-datetimebox datetime name="datetime" [ngModel]="myData.datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
                        helpText="Specify a date and a time" required></app-datetimebox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    <app-datetimebox date name="date" [ngModel]="myData.date" caption="Date" minDate="2024-05-01" helpText="Specify just a date and no time"></app-datetimebox>
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-datetimebox time name="time" [ngModel]="myData.time" caption="Time" [timeInterval]="10" helpText="Specify just a time and no date"></app-datetimebox>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="2" offset="4">
                    @if (tForm.enabled) {
                    <app-layout-row margin="">
                        <app-layout-column [width]="4">
                            <app-button primary width="100%" submit [disabled]="tForm.invalid">Save</app-button>
                        </app-layout-column>
                        <app-layout-column [width]="4">
                            <app-button secondary width="100%" (buttonClick)="templateFormCancel()">Cancel</app-button>
                        </app-layout-column>
                        <app-layout-column [width]="4">
                            <app-button tertiery width="100%" (buttonClick)="templateFormClear()">Clear</app-button>
                        </app-layout-column>
                    </app-layout-row>
                    } @else {
                    <app-button primary width="100%" (buttonClick)="templateFormEdit()">Edit</app-button>
                    }
                </app-layout-column>
                <app-layout-column [width]="2">
                    <app-button secondary width="100%" (buttonClick)="refresh()" [disabled]="!tForm.disabled">Reload</app-button>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="4" offset="4">
                    <div>Form: {{tForm.value | json}}</div>
                    <br />
                    <div>Data: {{this.myData | json}}</div>
                </app-layout-column>
            </app-layout-row>
        </app-layout-container>
    </form>
</div>

<br>

<!--  ----------  TWO-WAY BINDING  ----------  -->

<div style="border: 1px dashed">
    <app-layout-container fluid>
        <app-layout-row>
            <app-layout-column [width]="4">
                <span>Two-way binding</span>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="4" offset="4">
                <app-textbox [(ngModel)]="myData.name" caption="Name" helpText="Your full name"></app-textbox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="4" offset="4">
                <app-textbox [(ngModel)]="myData.email" caption="Email"></app-textbox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="1" offset="4">
                <app-textbox [(ngModel)]="myData.zip" caption="Zip"></app-textbox>
            </app-layout-column>
            <app-layout-column [width]="3">
                <app-textbox [(ngModel)]="myData.city" caption="City"></app-textbox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="4">
                <app-password [(ngModel)]="myData.passwordHash" caption="Password (Hashed)" section="twoWayHash" mode="hash" helpText="This is a hash based password"></app-password>
            </app-layout-column>
            <app-layout-column [width]="2">
                <app-password [(ngModel)]="myData.passwordSecret" caption="Password (Secret)" section="twoWaySecret" mode="secret" helpText="This is a secret based password"></app-password>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="4" offset="4">
                <app-xpath [(ngModel)]="myData.xpath" caption="XPath" required maxlength="20" helpText="What' you think?"></app-xpath>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="4">
                <app-singleselectbox caption="Background color" helpText="Please pick a color" [(ngModel)]="myData.backgroundColor" [dataSource]="colors" valueExpr="id"
                    displayExpr="name"></app-singleselectbox>
            </app-layout-column>
            <app-layout-column [width]="2">
                <app-singleselectbox caption="Foreground color" helpText="Please pick a color" [(ngModel)]="myData.foregroundColor" [dataSource]="colors" valueExpr="id"
                    displayExpr="name"></app-singleselectbox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="4">
                <app-multiselectbox caption="More colors" helpText="Please pick some colors" [(ngModel)]="myData.moreColors" [dataSource]="colors" valueExpr="id"
                    displayExpr="name"></app-multiselectbox>
            </app-layout-column>
            <app-layout-column [width]="2">
                <app-multiselectbox caption="Other colors" helpText="Please pick some colors" [(ngModel)]="myData.otherColors" [dataSource]="colors" valueExpr="id"
                    displayExpr="name"></app-multiselectbox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="4">
                <app-checkbox caption="Receive newsletter" [(ngModel)]="myData.receiveNewsletter"></app-checkbox>
            </app-layout-column>
            <app-layout-column [width]="2">
                <app-datetimebox datetime [(ngModel)]="myData.datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
                    helpText="Specify a date and a time"></app-datetimebox>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="4">
                <app-datetimebox date [(ngModel)]="myData.date" caption="Date" minDate="2024-05-01" helpText="Specify just a date and no time"></app-datetimebox>
            </app-layout-column>
            <app-layout-column [width]="2">
                <app-datetimebox time [(ngModel)]="myData.time" caption="Time" [timeInterval]="10" helpText="Specify just a time and no date"></app-datetimebox>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="4" offset="4">
                <div>Data: {{this.myData | json}}</div>
            </app-layout-column>
        </app-layout-row>
        <app-layout-row>
            <app-layout-column [width]="2" offset="6">
                <app-button secondary width="100%" (buttonClick)="refresh()">Reload</app-button>
            </app-layout-column>
        </app-layout-row>
    </app-layout-container>
</div>
